export const leadRateOptions = [
  { label: "Acquired", value: "Acquired" },
  { label: "Active", value: "Active" },
  { label: "Market Failed", value: "Market Failed" },
  { label: "Project Cancelled", value: "Project Cancelled" },
  { label: "Shut Down", value: "Shut Down" },
];

export const leadIndustryOptions = [
  {
    label: "ASP(Application Service Provider)",
    value: "ASP(Application Service Provider)",
  },
  { label: "Data/Telecom OEM", value: "Data/Telecom OEM" },
  {
    label: "ERP(Enterprise Resource Planning)",
    value: "ERP(Enterprise Resource Planning)",
  },
  { label: "Government/Military", value: "Government/Military" },
  { label: "Large Enterprise", value: "Large Enterprise" },
  { label: "Management ISV", value: "Management ISV" },
  {
    label: "MSP(Management Service Provider)",
    value: "MSP(Management Service Provider)",
  },
  {
    label: "Network Equipment Enterprise",
    value: "Network Equipment Enterprise",
  },
  { label: "Non-Management ISV", value: "Non-Management ISV" },
  { label: "Trade Show", value: "Trade Show" },
  { label: "Optical Networking", value: "Optical Networking" },
  { label: "Service Provider", value: "Service Provider" },
  { label: "Small/Medium Enterprise", value: "Small/Medium Enterprise" },
  { label: "Storage Equipment", value: "Storage Equipment" },
  { label: "Storage Service Provider", value: "Storage Service Provider" },
  { label: "System Integrator", value: "System Integrator" },
  { label: "Wireless Industry", value: "Wireless Industry" },
  { label: "ERP", value: "ERP" },
];

export const leadStatusOptions = [
  { label: "Attempted To Contact", value: "Attempted To Contact" },
  { label: "Contact In Future", value: "Contact In Future" },
  { label: "Contacted", value: "Contacted" },
  { label: "Junk Lead", value: "Junk Lead" },
  { label: "Lost Lead", value: "Lost Lead" },
  { label: "Not Contacted", value: "Not Contacted" },
  { label: "Pre-Qualified", value: "Pre-Qualified" },
];
export const leadSourceArray = [
  { label: "Advertisement", value: "Advertisement" },
  { label: "Cold Call", value: "Cold Call" },
  { label: "Employee Referral", value: "Employee Referral" },
  { label: "Online Store", value: "Online Store" },
  { label: "Partner", value: "Partner" },
  { label: "Public Relations", value: "Public Relations" },
  { label: "Sales Email Allas", value: "Sales Email Allas" },
  { label: "Seminar Partner", value: "Seminar Partner" },
  { label: "Internal Seminar", value: "Internal Seminar" },
  { label: "Trade Show", value: "Trade Show" },
  { label: "Web Download", value: "Web Download" },
  { label: "Advertisement", value: "Advertisement" },
  { label: "Web Research", value: "Web Research" },
  { label: "Chat", value: "Chat" },
];
